import { render, staticRenderFns } from "./AutoTxCard.vue?vue&type=template&id=5932e7e2&scoped=true&"
import script from "./AutoTxCard.vue?vue&type=script&lang=js&"
export * from "./AutoTxCard.vue?vue&type=script&lang=js&"
import style0 from "./AutoTxCard.vue?vue&type=style&index=0&id=5932e7e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5932e7e2",
  null
  
)

export default component.exports